export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: 'Is this digital? Do I have to wait for shipping?',
    answer:
      'It is 100% digital. You get instant PDF access after checkout — nothing is shipped. Carry the entire Vault on your phone, tablet or laptop, and print any lesson you want to take onto the court.',
  },
  {
    question: 'Does it work for all levels?',
    answer:
      'Absolutely. The 150 lessons run from complete beginners through to tournament players, and every volume includes progressions so you can pitch the same session up or down for the group in front of you.',
  },
  {
    question: 'What currency do I pay in?',
    answer:
      'The price adjusts to your local currency automatically at checkout. The launch price is $27 USD, charged once — there is no subscription and no upsell required to use the system.',
  },
  {
    question: 'How fast can I actually use it?',
    answer:
      'Open the Vault, choose the level and focus, and read the plan. Most coaches build a full professional session in about five minutes, which is exactly what the Emergency Lesson Plans bonus is designed for.',
  },
  {
    question: 'What if it isn’t right for me?',
    answer:
      'You are covered by the Iron-Clad 7-Day Guarantee. Use the drills, teach your toughest student with the system, and if you do not feel more professional and more organised, email us within 7 days for a full refund.',
  },
]
